"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[747],{

/***/ 79747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ DashboardLayout; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/antd/es/row/index.js
var row = __webpack_require__(3306);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/ArrowBack.js
var ArrowBack = __webpack_require__(28504);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/PersonAddAlt1.js
var PersonAddAlt1 = __webpack_require__(22586);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/router/index.tsx + 1 modules
var src_router = __webpack_require__(41689);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/firebase/auth/context.tsx
var context = __webpack_require__(21728);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/AppContext/index.tsx + 1 modules
var AppContext = __webpack_require__(49194);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/message/index.ts
var message = __webpack_require__(7476);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/firebase/auth/FirebaseClaims.tsx
var FirebaseClaims = __webpack_require__(93598);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/antd/es/tooltip/index.js + 5 modules
var tooltip = __webpack_require__(31136);
// EXTERNAL MODULE: ../../libs/data-access/src/generated/index.tsx + 5 modules
var generated = __webpack_require__(20229);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
// EXTERNAL MODULE: ../../node_modules/antd/es/switch/index.js + 1 modules
var es_switch = __webpack_require__(49783);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/Switch/index.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.ant-switch {\n    height: 38px;\n    width: 115px;\n    .ant-switch-handle {\n      border-radius: 50%;\n      height: 20px;\n      width: 20px;\n      top: 9px;\n      left: 9px;\n    }\n    .ant-switch-inner {\n      font-weight: 600;\n      margin-left: 20px;\n    }\n    .ant-switch-handle::before {\n      border-radius: 50%;\n    }\n  }\n  &.ant-switch-checked .ant-switch-inner {\n    margin-left: 10px;\n  }\n  &.ant-switch-checked .ant-switch-handle {\n    height: 20px;\n    width: 20px;\n    left: calc(100% - 20px - 9px);\n  }\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const Switch = (0,styled_components_browser_esm/* default */.ZP)(es_switch/* default */.Z)(_templateObject(), (param)=>{
    let { color  } = param;
    return color && "\n    &.ant-switch-checked {\n      background-color: ".concat(color, "!important;\n    }\n  ");
});

// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/theme.ts
var theme = __webpack_require__(32657);
// EXTERNAL MODULE: ../../node_modules/nosleep.js/src/index.js
var src = __webpack_require__(27809);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/vetter/OnlineOfflineSwitch/styles.ts

function styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #fff;\n  text-decoration: underline;\n\n  &:hover {\n    color: #fff;\n  }\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}

const Link = styled_components_browser_esm/* default.a */.ZP.a(styles_templateObject());

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/vetter/OnlineOfflineSwitch/index.tsx








const OnlineOfflineSwitch = (param)=>{
    let { userId  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    const noSleepRef = (0,react.useRef)();
    const [updateUserPresence] = (0,generated/* useUpdatePresenceMutation */.I3l)();
    const { data , loading  } = (0,generated/* useUserPresenceQuery */.Hcm)({
        variables: {
            userId
        }
    });
    (0,generated/* useVetterUpdatedSubscription */.NXk)({
        variables: {
            userId
        }
    });
    const checked = (data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.presence) === generated/* UserPresenceEnum.ONLINE */.kWY.ONLINE || (data === null || data === void 0 ? void 0 : (ref1 = data.user) === null || ref1 === void 0 ? void 0 : ref1.presence) === generated/* UserPresenceEnum.BUSY */.kWY.BUSY;
    const updateVetter = (0,react.useCallback)(async ()=>{
        var ref, ref1;
        const newStatus = checked ? (data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.presence) === generated/* UserPresenceEnum.BUSY */.kWY.BUSY ? generated/* UserPresenceEnum.ONLINE */.kWY.ONLINE : generated/* UserPresenceEnum.OFFLINE */.kWY.OFFLINE : generated/* UserPresenceEnum.ONLINE */.kWY.ONLINE;
        if (checked) {
            var ref2;
            await ((ref2 = noSleepRef.current) === null || ref2 === void 0 ? void 0 : ref2.enable());
        } else {
            var ref3;
            (ref3 = noSleepRef.current) === null || ref3 === void 0 ? void 0 : ref3.disable();
        }
        const { data: mutationData  } = await updateUserPresence({
            variables: {
                userId,
                presence: newStatus
            },
            optimisticResponse: {
                __typename: "Mutation",
                updateUserPresence: {
                    __typename: "User",
                    id: userId,
                    presence: newStatus
                }
            }
        });
        if ((mutationData === null || mutationData === void 0 ? void 0 : (ref1 = mutationData.updateUserPresence) === null || ref1 === void 0 ? void 0 : ref1.__typename) === "ValidationError") {
            var ref4;
            message/* message.error */.y.error((ref4 = mutationData.updateUserPresence.messages) === null || ref4 === void 0 ? void 0 : ref4[0]);
        }
    }, [
        updateUserPresence,
        userId,
        checked,
        data === null || data === void 0 ? void 0 : (ref2 = data.user) === null || ref2 === void 0 ? void 0 : ref2.presence
    ]);
    const accountSetupCompleted = (data === null || data === void 0 ? void 0 : (ref3 = data.user) === null || ref3 === void 0 ? void 0 : ref3.isProfileDataProvided) && (data === null || data === void 0 ? void 0 : (ref4 = data.user) === null || ref4 === void 0 ? void 0 : ref4.isProfilePhotoProvided);
    const isApproved = (data === null || data === void 0 ? void 0 : (ref5 = data.user) === null || ref5 === void 0 ? void 0 : ref5.approvalStatus) === "ACTIVE";
    const canVette = accountSetupCompleted && isApproved;
    let tooltipMessage = "Before you start Vetting you must first provide your profile photo.";
    if (accountSetupCompleted && !isApproved) {
        tooltipMessage = "Your account must be approved before you are able to start Vetting";
    }
    if (canVette) {
        var ref9;
        tooltipMessage = (data === null || data === void 0 ? void 0 : (ref9 = data.user) === null || ref9 === void 0 ? void 0 : ref9.presence) === generated/* UserPresenceEnum.ONLINE */.kWY.ONLINE ? "While you are online, you can expect to receive interview requests" : "While you are offline, you will not get incoming Vettes.";
    }
    (0,react.useEffect)(()=>{
        const noSleepLock = new (src_default())();
        noSleepRef.current = noSleepLock;
    });
    if (!(data === null || data === void 0 ? void 0 : (ref6 = data.user) === null || ref6 === void 0 ? void 0 : ref6.photoHighUrl)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch, {
            disabled: false,
            checkedChildren: generated/* UserPresenceEnum.ONLINE */.kWY.ONLINE || generated/* UserPresenceEnum.BUSY */.kWY.BUSY,
            unCheckedChildren: generated/* UserPresenceEnum.OFFLINE */.kWY.OFFLINE,
            checked: checked,
            onClick: ()=>message/* message.error */.y.error(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Oops! Please upload a profile photo in",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                            href: "/settings",
                            children: "Settings"
                        }),
                        " to go online."
                    ]
                })),
            loading: loading
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
        title: tooltipMessage,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch, {
            "aria-label": checked ? "Go Offline" : "Go Online",
            disabled: !canVette,
            checkedChildren: (data === null || data === void 0 ? void 0 : (ref7 = data.user) === null || ref7 === void 0 ? void 0 : ref7.presence) === generated/* UserPresenceEnum.ONLINE */.kWY.ONLINE ? generated/* UserPresenceEnum.ONLINE */.kWY.ONLINE : generated/* UserPresenceEnum.BUSY */.kWY.BUSY,
            unCheckedChildren: generated/* UserPresenceEnum.OFFLINE */.kWY.OFFLINE,
            checked: checked,
            onClick: updateVetter,
            loading: loading,
            color: (data === null || data === void 0 ? void 0 : (ref8 = data.user) === null || ref8 === void 0 ? void 0 : ref8.presence) === generated/* UserPresenceEnum.BUSY */.kWY.BUSY ? theme/* theme.colors.yellow100 */.r.colors.yellow100 : undefined
        })
    });
};

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/DashboardLayout/Sider/styles.ts

function Sider_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 249px;\n  height: 100vh;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  padding-bottom: 24px;\n\n  @media print {\n    display: none;\n  }\n"
    ]);
    Sider_styles_templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 20px;\n  margin: 36px;\n  cursor: pointer;\n  margin-right: ",
        ";\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 0 1;\n  flex-direction: row;\n\n  align-items: center;\n  justify-content: flex-start;\n  padding-left: 40px;\n  min-height: 60px;\n  cursor: pointer;\n\n  color: ",
        ";\n  font-weight: 600;\n  font-size: 15px;\n  & > svg {\n    color: ",
        ";\n    margin-right: 14px;\n  }\n\n  &:hover {\n    background: linear-gradient(\n      90deg,\n      rgba(0, 0, 0, 0.08) 0%,\n      rgba(0, 0, 0, 0.08) 53.91%,\n      rgba(0, 0, 0, 0) 100%\n    );\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}

const Wrapper = styled_components_browser_esm/* default.div */.ZP.div(Sider_styles_templateObject());
const SubMenuWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1());
const Logo = styled_components_browser_esm/* default.img */.ZP.img(_templateObject2(), (param)=>{
    let { hasStatusToggle  } = param;
    return hasStatusToggle ? "20px " : "36px";
});
const MenuItem = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3(), (param)=>{
    let { theme , active  } = param;
    return active ? theme.colors.white : theme.colors.white60;
}, (param)=>{
    let { theme , active  } = param;
    return active ? theme.colors.white : theme.colors.white60;
});

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/DashboardLayout/Sider/index.tsx








const Sider = (param)=>{
    let { hasStatusToggle , fullLogo  } = param;
    var ref;
    const { router , getPath  } = (0,src_router/* useCustomRouter */.cD)();
    const { logout , claims  } = context/* useFirebase */.f2();
    const appContext = (0,AppContext/* useAppContext */.bp)();
    const sideMenu = appContext === null || appContext === void 0 ? void 0 : appContext.sideMenu;
    const takeAction = async (actionType)=>{
        switch(actionType){
            case "logout":
                await logout();
                message/* message.destroy */.y.destroy();
                router.replace("/login");
                break;
            case "goToSettings":
                router.replace("/settings");
                break;
            default:
                return;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        passHref: true,
                        href: (ref = sideMenu[0]) === null || ref === void 0 ? void 0 : ref.route,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                            src: fullLogo ? "/fullLogo.svg" : "/logo.svg",
                            hasStatusToggle: hasStatusToggle
                        })
                    }),
                    hasStatusToggle && /*#__PURE__*/ (0,jsx_runtime.jsx)(FirebaseClaims/* FirebaseClaims */.h, {
                        required: {
                            id: true
                        },
                        children: (param)=>{
                            let { id  } = param;
                            return id && /*#__PURE__*/ (0,jsx_runtime.jsx)(OnlineOfflineSwitch, {
                                userId: id
                            });
                        }
                    }),
                    sideMenu.filter((menuItem)=>!menuItem.bottom).filter((menuItem)=>typeof menuItem.shouldDisplay !== "function" || menuItem.shouldDisplay({
                            claims
                        })).map((param)=>/*#__PURE__*/ {
                        let { title , route , icon  } = param;
                        return (0,jsx_runtime.jsx)((link_default()), {
                            href: getPath(route),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem, {
                                "aria-label": title,
                                active: (0,src_router/* removeAdminPath */.Fz)(router.asPath).startsWith(route) || route.includes("/applicants") && router.asPath.includes("/sessions/view"),
                                children: [
                                    icon,
                                    title
                                ]
                            })
                        }, title);
                    })
                ]
            }),
            (0,src_router/* isAdminAsClient */.mT)(router.asPath) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubMenuWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: getPath("/team-members"),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem, {
                            onClick: ()=>takeAction("goToTeamMembers"),
                            active: (0,src_router/* removeAdminPath */.Fz)(router.asPath).startsWith("/team-members"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonAddAlt1/* default */.Z, {}),
                                "Team Members"
                            ]
                        })
                    }, "Team Members"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/clients",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem, {
                            active: false,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {}),
                                "Clients"
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SubMenuWrapper, {
                children: sideMenu.filter((menuItem)=>menuItem.bottom).filter((menuItem)=>typeof menuItem.shouldDisplay !== "function" || menuItem.shouldDisplay({
                        claims
                    })).map((param)=>{
                    let { icon , title , route , actionType  } = param;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: getPath(route),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem, {
                            "aria-label": title,
                            onClick: ()=>takeAction(actionType),
                            active: (0,src_router/* removeAdminPath */.Fz)(router.asPath).startsWith(route),
                            children: [
                                icon,
                                title
                            ]
                        })
                    }, title);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../libs/frontend-utils/src/hooks/useRole.ts
var useRole = __webpack_require__(21335);
// EXTERNAL MODULE: ../../node_modules/antd/es/layout/index.js + 9 modules
var layout = __webpack_require__(17332);
// EXTERNAL MODULE: ../../node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(48562);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/DashboardLayout/styles.ts

function DashboardLayout_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100vh;\n  width: 100vw;\n  background: transparent;\n  overflow-y: hidden;\n  background: url('/images/boarding.svg') no-repeat center center fixed;\n  background-size: cover;\n\n  @media print {\n    height: auto;\n    overflow: visible;\n  }\n"
    ]);
    DashboardLayout_styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: ",
        ";\n  opacity: ",
        ";\n  transition: opacity 0.25s ease-in-out;\n  pointer-events: none;\n  z-index: ",
        ";\n"
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      overflow-y: ",
        ";\n    "
    ]);
    styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  width: 650px;\n\n  ",
        "\n"
    ]);
    styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 0 auto;\n  flex-direction: column;\n  padding: 48px 72px;\n  border-radius: 18px;\n  background: ",
        ";\n  margin: 36px;\n  gap: 72px;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n\n  .ant-skeleton-title {\n    border-radius: ",
        ";\n    height: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}


const styles_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(layout/* default */.Z)(DashboardLayout_styles_templateObject());
const DarkModeOverlay = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, (param)=>{
    let { $darkMode  } = param;
    return $darkMode ? 0.5 : 0;
}, (param)=>{
    let { $404  } = param;
    return $404 ? 1000 : "unset";
});
/* 
Without 'width: <N>px' border of layout becomes hidden when size changed 
You could test it if add style 'border: 3px solid red;'
*/ const Layout = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject3(), (param)=>{
    let { $overflowY  } = param;
    return $overflowY && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject2(), $overflowY);
});
const PagePlaceholder = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "PagePlaceholder"
})(_templateObject4(), (param)=>{
    let { theme  } = param;
    return theme.colors.white;
});
const SKELETON_HEIGHT = {
    small: "32px",
    medium: "40px",
    large: "48px"
};
const SkeletonBox = (0,styled_components_browser_esm/* default */.ZP)(skeleton/* default */.Z).attrs((param)=>{
    let { paragraph =false , title =true  } = param;
    return {
        title,
        paragraph,
        active: true
    };
})(_templateObject5(), (param)=>{
    let { width ="100%"  } = param;
    return width;
}, (param)=>{
    let { rounded  } = param;
    return rounded ? "12px" : "8px";
}, (param)=>{
    let { size  } = param;
    return SKELETON_HEIGHT[size];
});

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/DashboardLayout/index.tsx








const DashboardLayout = (param)=>{
    let { children , loading , hasStatusToggle , fullLogo , overflowY  } = param;
    var ref;
    const { claims  } = context/* useFirebase */.f2();
    const { router  } = (0,src_router/* useCustomRouter */.cD)();
    const { isClientManager  } = useRole/* useRole */.q();
    const isEligibleForInterview = !isClientManager && !(0,src_router/* isAdminAsClient */.mT)(router.asPath);
    var ref1;
    const { data  } = (0,generated/* useUserPresenceQuery */.Hcm)({
        variables: {
            userId: (ref1 = claims === null || claims === void 0 ? void 0 : claims.id) !== null && ref1 !== void 0 ? ref1 : ""
        },
        skip: !(claims === null || claims === void 0 ? void 0 : claims.id) || !isEligibleForInterview || !hasStatusToggle
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    const darkMode = (data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.presence) === generated/* UserPresenceEnum.OFFLINE */.kWY.OFFLINE && theme.config.allowDarkMode;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Wrapper, {
        hasSider: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DarkModeOverlay, {
                $darkMode: darkMode,
                $404: fullLogo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Sider, {
                fullLogo: fullLogo,
                hasStatusToggle: hasStatusToggle && isEligibleForInterview
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
                $overflowY: overflowY,
                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(PagePlaceholder, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                            justify: "space-between",
                            align: "middle",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonBox, {
                                    width: "420px",
                                    size: "medium"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonBox, {
                                    width: "130px",
                                    size: "large",
                                    rounded: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonBox, {
                            size: "small",
                            paragraph: true,
                            title: true
                        })
                    ]
                }) : children
            })
        ]
    });
};


/***/ })

}]);